
import { PropType } from 'vue'
import Log from '@/views/Log/models/log'
import { serialise } from 'kitsu-core'
import { getURL } from '@/utils/axios'
import { patchRequest } from '@/plugins/api-axios'
import LogMixin from '@/_mixins/log'
import TimeDuration from '@/views/Project/ch/components/workAlert/timeDuration.vue'
import moment from 'moment'

export default {
    name: 'AlertLogItems',
    mixins: [LogMixin],
    components: { TimeDuration },
    props: {
        logs: {
            type: Array as PropType<Log[]>,
            required: true,
            default: () => [],
        },
        logReadState: {
            type: Object as PropType<Record<string, boolean>>,
            required: true,
        },
        canMarkAllAsRead: {
            type: Boolean,
        },
    },
    watch: {
        logs: {
            handler: 'groupLogsData',
        },
    },
    data() {
        return {
            marking: false,
            currentLogId: '',
            groupedLogs: {},
        }
    },
    created() {
        this.groupLogsData()
    },
    methods: {
        async markAsRead(logId: string, index: number) {
            try {
                this.marking = true
                this.currentLogId = logId
                await patchRequest(
                    getURL({
                        path: `/events/${logId}`,
                        base: this.logURL,
                    }),
                    {},
                    serialise('event', { id: logId, isRead: true }).data
                )
                this.$emit('read', logId, index)
            } finally {
                this.marking = false
                this.currentLogId = ''
            }
        },
        async markAsUnRead(logId: string, index: number) {
            try {
                this.marking = true
                this.currentLogId = logId
                await patchRequest(
                    getURL({
                        path: `/events/${logId}`,
                        base: this.logURL,
                    }),
                    {},
                    serialise('event', { id: logId, isRead: false }).data
                )
                this.$emit('unread', logId, index)
            } finally {
                this.marking = false
                this.currentLogId = ''
            }
        },
        groupLogsData() {
            const groups: any = {
                today: [],
                yesterday: [],
                thisWeek: [],
                lastWeek: [],
                thisMonth: [],
                lastMonth: [],
                older: [],
            }
            const today = moment()
            this.logs.forEach((item: any) => {
                const itemDate = moment(item.time)
                if (itemDate.isSame(today, 'day')) {
                    groups['today'].push(item)
                } else if (itemDate.isSame(today.clone().subtract(1, 'days'), 'day')) {
                    groups['yesterday'].push(item)
                } else if (itemDate.isSame(today, 'week')) {
                    groups['thisWeek'].push(item)
                } else if (itemDate.isSame(today.clone().subtract(1, 'weeks'), 'week')) {
                    groups['lastWeek'].push(item)
                } else if (itemDate.isSame(today, 'month')) {
                    groups['thisMonth'].push(item)
                } else if (itemDate.isSame(today.clone().subtract(1, 'months'), 'month')) {
                    groups['lastMonth'].push(item)
                } else {
                    groups['older'].push(item)
                }
            })

            this.groupedLogs = groups
        },
        async markAllAsRead(type: string) {
            const ids =
                this.groupedLogs[type] && this.groupedLogs[type].length > 0
                    ? this.groupedLogs[type].map((item: any) => item._id)
                    : []
            this.$emit('onMarkAllAsRead', true, { type, items: ids })
        },
    },
}
